import { connect } from "react-redux";

import {
    addFileAction,
    addFilesAction,
    removeFileAction,
    replaceFileAction,
    replaceFilesAction,
} from "../../../Engine/ActionCreators/AttachmentActionCreators";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { CustomFile } from "../../../Helpers/file";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withControlDebugInfo } from "../../withControlDebugInfo";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { withFocusManagement } from "../../Services/FocusManagement/withFocusManagement";
import { AbsoluteResolvedModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { AttachmentInfoPath } from "../../../../../Common/PathConstants";

import { FileLoader } from "./FileLoader";

interface FileLoaderContainerProps {
    bindingPath: AbsoluteResolvedModelPath;
    viewModelSelect: ViewModelSelect;
    multiple: boolean;
}

const mapStateToProps = (state: FullFormState, ownProps: FileLoaderContainerProps) => {
    const { bindingPath, viewModelSelect } = ownProps;
    const instances = viewModelSelect.children(state, bindingPath);
    const hasSingleAttachment = viewModelSelect.customFieldValueOrUndefined(
        state,
        bindingPath.joinWith(AttachmentInfoPath),
        "value"
    );
    const hasMultipleAttachment = viewModelSelect.customFieldValueOrUndefined(
        state,
        bindingPath.joinWith("0").joinWith(AttachmentInfoPath),
        "value"
    );
    return {
        instances: instances,
        hasFiles: hasSingleAttachment != undefined || hasMultipleAttachment != undefined,
        attachments: state.attachments,
        isReadOnly: Boolean(state.settings.isReadOnly),
    };
};

const mapDispatchToProps = (dispatch: CandyDispatch, ownProps: FileLoaderContainerProps) => {
    const onAddFiles = (files: CustomFile[] | CustomFile): Promise<void> => {
        if (!Array.isArray(files)) {
            return dispatch(addFileAction(ownProps.bindingPath, files));
        }
        return dispatch(addFilesAction(ownProps.bindingPath, files));
    };
    const onReplaceFiles = (
        newFiles: CustomFile[] | CustomFile,
        replaceInstances: readonly string[]
    ): Promise<void> => {
        if (!Array.isArray(newFiles)) {
            return dispatch(replaceFileAction(ownProps.bindingPath, newFiles));
        }
        return dispatch(replaceFilesAction(ownProps.bindingPath, newFiles, replaceInstances));
    };
    return {
        onReplaceFiles: onReplaceFiles,
        onAddFiles: onAddFiles,
        onRemoveAttachment: () => dispatch(removeFileAction(ownProps.bindingPath)),
    };
};

export const FileLoaderContainer = withResolvePaths(
    withViewModelSelect(
        connect(mapStateToProps, mapDispatchToProps)(withFocusManagement(withControlDebugInfo(FileLoader)))
    )
);
